// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategories";
import { TurnerCategoryModel } from "@turnerBlueprint/App/Services/TurnerApiModels";

function GetRandomCategories(props: any) {
    let i = 0;
    const numbers: number[] = [];
    const max = 12;
    if (props.apiResult.categoryIds == null || props.apiResult.categoryIds.length < 12) {
        return;
    }
    while (i < max) {
        i++;
        const random = Math.floor(Math.random() * props.apiResult.categoryIds.length);
        if (numbers.includes(random)) {
            continue;
        }
        numbers.push(random);
        if (props.apiResult.categoriesById[props.apiResult.categoryIds[random]] !== undefined) {
            (props.apiResult.categoriesById[props.apiResult.categoryIds[random]] as TurnerCategoryModel)!.random = true;
        }
    }
}

addToChainAfter(chain, RequestDataFromApi, GetRandomCategories);
